@if (vm$ | async; as vm) {
  <div class="mt-3">
    <p-card>
      <div class="grid">
        <div class="title4Font mb-2 pl-4 col-9"
             i18n>
          {{ vm.detail.titleName }}
        </div>

        <div class="subtitle3Font col-3 pl-8">
          <div class="mb-2 flex justify-content-start"
               i18n>
            ISBN: {{ vm.detail.titleIsbn }}
          </div>
          <div class="flex justify-content-start"
               i18n>
            Journal: {{ vm.detail.kurzel }}
          </div>
        </div>

        @if (vm.showActions) {
          <div class="col-12 pl-3 flex gap-3">
            @if (vm.isManager) {
              <p-button (onClick)="applyChanges()"
                        label="Apply Changes"
                        i18n-label
                        [disabled]="!vm.detail.reportFile">
              </p-button>
            }

            <p-button (onClick)="generateReport()"
                      label="Generate Report"
                      i18n-label
                      [loading]="isGeneratingReport"
                      styleClass="p-button-outlined">
            </p-button>

            @if (vm.isManager) {
              <p-button (onClick)="returnToEditors()"
                        label="Return to Editors"
                        i18n-label
                        styleClass="p-button-outlined">
              </p-button>

              <p-button (onClick)="cancel()"
                        label="Cancel Project"
                        i18n-label
                        styleClass="p-button-outlined">
              </p-button>
            }
          </div>

          @if (vm.detail.reportFile) {
            <div class="col-12 pl-3 flex align-items-center gap-2">
              <span class="subtitle3Font"
                    i18n>Report:</span>
              <sc-file-download [fileInfo]="vm.detail.reportFile"
                                [download$]="downloadReport$">
              </sc-file-download>
            </div>
          }
        }

        @if (vm.showImportPapers) {
          <div class="col-12 pl-3">
            <p-button (onClick)="importPapers()"
                      label="Import Papers"
                      i18n-label>
            </p-button>
          </div>
        }
      </div>
    </p-card>
  </div>
}